
import { createAsyncReducer } from 'utils/Redux';

import { getLinkInviteActions } from '../actions';

export default createAsyncReducer<string, string>(
    getLinkInviteActions
);
